import { render } from "./AirbitPage.vue?vue&type=template&id=4039e6fc&scoped=true"
import script from "./AirbitPage.vue?vue&type=script&lang=js"
export * from "./AirbitPage.vue?vue&type=script&lang=js"

import "./AirbitPage.vue?vue&type=style&index=0&id=4039e6fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4039e6fc"]])

export default __exports__